module.exports = __webpack_public_path__ + "static/moonstone-112e51e3044609b0487f7fae6c9451bf.svg";